<template>
  <div class="course">
    <course-banner />
    <div class="course-body">
      <div class="course-content">
        <ue-tabs :tabs="tabs" @loadPost="loadCourseList" />
        <course-card v-for="item in courseList.posts" :course="item" :key="item._id"/>
        <div style="width: 850px; margin-top: 41px;" v-if="!courseList.isLastPage">
          <span class="ue-btn ue-btn-filling" style="width: 620px;" @click="loadMore">查看更多课程</span>
        </div>
      </div>
      <div>
        <course-rate style="margin-top: 34px" :courses="rankCourses" />
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import CourseBanner from '@/components/course/CourseBanner.vue'
import CourseCard from '@/components/course/CourseCard.vue'
import CourseRate from '@/components/course/CourseRate.vue'
import UeTabs from '@/components/home/UeTabs'
export const courseTabs = [
  {
    id: "",
    name: '最新课程',
    enname: 'newProducts'
  },
  {
    id: "5f687e7ee76d15d6a58e6105",
    name: '设计思维',
    enname: 'competingProducts'
  },{
    name: '设计规范',
    id: "5f687e8be76d15d6a58e6106",
    enname: 'design'
  },{
    name: '实战分享',
    id: "5f687e95e76d15d6a58e6107",
    enname: 'research'
  },{
    name: '方法教程',
    id: "5f687e95e76d15d6a58e6108",
    enname: 'case'
  }
]
export default {
  name: 'course',
  data () {
    return {
      tabs: courseTabs,
    }
  },
  components: {
    CourseBanner, CourseCard, CourseRate, UeTabs
  },
  computed: {
    ...mapGetters('post', ['courseList']),
    ...mapGetters('home', ['rankCourses'])
  },
  methods: {
    ...mapActions('post', ['getCourseList']),
    ...mapActions('home', ['getRankCourses']),
    loadMore () {
      if(!this.courseList.isLastPage) {
        this.getCourseList({p: parseInt(this.courseList.page) + 1, loadMore: true});
      }
    },
    loadCourseList (id) {
      this.getCourseList({ca: id, p: 1});
    }
  },
  created () {
    this.getCourseList({p: 1})
    this.getRankCourses()
  }
}
</script>
<style lang="scss" scoped>
.course {
  padding-top: 20px;
  .course-body {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    >.course-content {
      width: 850px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      >* {
        margin: 50px 0 0 0;
      }
    }
  }
}
</style>


